module.exports = __webpack_public_path__ + "img/the-lady-of-the-rivers.1226ebf0.png";